<template>
  <div class="success-content">
    <div class="success">
      <!-- <img src="../image/yky/兑换成功.png" alt=""> -->
      <img src="../image/success.png" alt="" />
      <!-- <p>兑换成功</p> -->
      <p>支付成功</p>
    </div>
    <div class="btn-box">
      <span class="back" @click="goActivity">返回主页</span>
      <span class="order" @click="goOrder">查看订单</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: this.$route.query.data || {},
    };
  },
  mounted() {
  },
  methods: {
    goActivity() {
      this.$router.push('/activity')
    },
    goOrder() {
      this.$router.push('/exchangeList?type=2')
    }
  }
};
</script>

<style lang="scss" scoped>
.success-content {
  .success {
    width: 100%;
    height: 160px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
    img {
      width: 60px;
      height: 60px;
    }
    p {
      font-size: 18px;
      font-weight: bold;
      margin-top: 20px;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    padding: 0 33px;
    justify-content: space-between;
    span {
      display: block;
      width: 138px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 20px;
    }
    .back {
      background: #F5F6FA;
      border:1px solid #D80A68;
      color: #D80A68;
      &:active {
        background: #fff;
      }
    }
    .order {
      background: #D80A68;
      border:1px solid #D80A68;
      color: #FFFFFF;
      &:active {
        background: rgba(216, 10, 104, .8);
      }
    }
  }
}
</style>